import PublicLayout from "@/components/layouts/bootstrap/PublicLayout";
import Seo from "@/components/Seo";
import Link from "next/link";
import { useRouter } from "next/router";
import { Image } from 'react-bootstrap';

export default function Education()
{

    const router = useRouter();
    return (
        <>
            <Seo
                title="Live Polling for Education | Classroom Engagement Tool"
                description="Engage students and collect instant classroom feedback using live polling software designed for teachers and educators."
                canonical="https://instantpolls.online/education"
            />
            <section className="hero-reseller education-reseller d-flex align-items-center text-white">
                <div className="container hero-inner">
                    <div className="hero-copy d-inline-block">
                        <h1 className="publicBannerHeading">Education & Training</h1>
                    </div>
                </div>
                <Link
                    className="btn btn-info text-white mt-3 float-end"
                    href="/industry_questions"
                >
                    VIEW EXPERT QUESTIONS
                </Link>
            </section>

            <section className="py-5 bg-white">
                <div className="container">
                    <div className="mb-4">
                        <button
                            onClick={() => router.back()}
                            className="button btn-purple me-3 text-uppercase border-0 p-2 px-3"
                        >
                            Back
                        </button>
                        <Link className="button btn-purple me-3" href="/contact">BOOK A DEMO</Link>
                        <Link className="button btn-purple me-3" href="/register">REGISTER</Link>
                        <Link className="button btn-purple me-3" href="/pricing">PRICING</Link>
                        <Link className="button btn-purple me-3" href="/register">TRY A FREE POLL</Link>

                        <Link className="button btn-purple" href="/faq">FAQ</Link>
                    </div>
                    <div className="row align-items-center">

                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold mb-4 publicTextNew">
                                Engage every learner. Improve outcomes in real time.
                            </h2>
                            <p className="text-muted mb-3">
                                <b>Active learning</b> happens in moments — the questions, reflections, and discussions that can shift understanding instantly. But without <b>real-time feedback</b>, educators and corporate trainers are left guessing whether their message is landing. </p>
                            <p className="text-muted mb-3">
                                Whether you’re running a university lecture, a professional workshop, or an <b> online course</b>, Instant Polls lets you capture <b> live feedback</b>, gauge <b>learner comprehension</b>, and adapt your approach — while <b> student engagement</b> is at its peak. </p>
                            <p className="text-muted">
                                Because when teachers and trainers use <b>formative assessment</b> to see what learners think in real time, every session becomes smarter, more responsive, and more effective
                            </p>
                        </div>
                        <div className="col-lg-6 text-center">
                            <Image src="/industry/education-classroom-polling.png" alt="classroom polling tool for student engagement" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-blue">
                <div className="container text-center">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Challenge</h5>
                                    <p className="card-text text-muted">
                                        Traditional <b>feedback tools</b> gather data long after the learning moment has passed. By the time results are reviewed, the class has moved on, the<b> corporate training</b> session is over, and the opportunity to adapt has been lost.
                                    </p>
                                    <p className="card-text text-muted">
                                        Educators and facilitators need <b> real-time feedback</b> they can trust — instantly, in the room, while the conversation is still alive. Without <b>formative assessment</b> in the moment, it is impossible to measure <b>student engagement</b> or adjust your <b>instructional design</b> to meet the needs of the learners.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Solution</h5>
                                    <p className="card-text text-muted">
                                        You can ask <b>comprehension questions</b> mid-session, gauge <b> audience engagement</b> levels, or collect <b> real-time feedback</b> on delivery and pace — and see the results unfold live before your eyes.
                                    </p>
                                    <p className="card-text text-muted">
                                        Our <b>AI-powered analytics</b> interpret sentiment and highlight <b>data trends</b>, giving you a clear picture of where <b>learner understanding</b> is strong and where additional support is needed.
                                    </p>
                                    <p className="card-text text-muted">
                                        Built with <b>enterprise-grade privacy</b>, flexible <b>custom branding</b>, and no <b>subscription software</b> requirements, it is the ultimate tool for secure, on-demand interaction.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 col-lg-4">
                            <div className="card border-0 h-100 bg-unset">
                                <div className="card-body">
                                    <h5 className="card-title bu-semibold mb-3 text-start" >The Result</h5>
                                    <p className="card-text text-muted">
                                        From  <b>classrooms</b> to <b>corporate training programs</b>, Instant Polls helps educators close the <b>feedback loop </b>in real time. It transforms passive audiences into <b> active participants</b>, builds stronger <b> learner engagement</b>, and drives measurable improvements in <b> learning outcomes</b> and student satisfaction.
                                    </p>
                                    <p className="card-text text-muted">
                                        Our<b> educational technology</b> ensures that when you ask better questions, you teach more effectively—and your learners achieve higher <b> academic success</b>.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="features py-5">
                <div className="container">
                    <h2 className="text-center fw-bold mb-4 highlightedColor">How Instant Polls Works</h2>

                    <div className="row g-4">
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/dashboard.png" alt="polls analytics dashboard icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Real-Time Dashboards</div>
                                    <p className="rfeature-text">Result stream in live, no refresh required.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/artificial-intelligence.png" alt="AI-powered polling intelligence icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">AI-Powered Sentiment</div>
                                    <p className="rfeature-text">Understand tone and context, not just raw numbers.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/segmentation.png" alt="audience segmentation icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Segmentation</div>
                                    <p className="rfeature-text">Break results down by department, region, or demographics.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/system.png" alt="system integration icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Seamless Integration</div>
                                    <p className="rfeature-text">Works with Microsoft Teams, Slack, CRMs, and more.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/cyber-security-icon.png" alt="data security and privacy icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">Enterprise-Grade Security</div>
                                    <p className="rfeature-text">Anonymous by default, encrypted end-to-end</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="rfeature-card d-flex">
                                <div className="rfeature-icon">
                                    <Image src="/industry/icons/outline.png" alt="reporting and insights icon" className="img-fluid" />
                                </div>
                                <div>
                                    <div className="rfeature-title">White-Label Branding</div>
                                    <p className="rfeature-text">Brand every poll as your own.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 publicNewBgvColor">
                <div className="container testimonials">
                    <h2 className="mb-5 text-purple">Hear From Our Users</h2>
                    <div className="row g-4">
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Instant Polls changed how we run leadership meetings. We get clarity in minutes instead of waiting on surveys.”</p>
                                <cite>Managing Director, Professional Services</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“As an event organiser, I finally have live engagement metrics to show sponsors real ROI.”</p>
                                <cite>Event Manager</cite>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="bs-quotes">
                                <p>“Our students love it. Real-time feedback makes learning more interactive.”</p>
                                <cite>University Lecturer</cite>
                            </div>
                        </div>
                    </div>
                </div>
            </section >

            <section className="lead-section-edu d-flex align-items-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 py-5">
                            <h3 className="fw-bold mb-3 publicPageNewTextColor">Make learning live,<br />engaging, and measurable.</h3>
                            <p className="text-muted mb-3">
                                Discover how Instant Polls can help you transform <b> student feedback</b> into learning, spark <b> active participation</b>, and make every session more impactful.
                            </p>
                            <p className="text-muted mb-4">
                                Whether you&#39;re teaching, training, or leading <b> professional development</b>, Instant Polls gives you the <b> formative assessment</b> tools and connection that make learning stick.
                            </p>
                            <Link href="/contact" className="btn btn-purple rounded-pill px-4 py-2" >BOOK A DEMO</Link>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

Education.getLayout = (page) => <PublicLayout>{page}</PublicLayout>;